import { render, staticRenderFns } from "./ClosedProjectsPortfolio.vue?vue&type=template&id=9146c0c2"
import script from "./ClosedProjectsPortfolio.vue?vue&type=script&lang=js"
export * from "./ClosedProjectsPortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports